<template>
    <div @click="updateSubscriptionPlan()" class="border flex flex-col h-full overflow-hidden relative rounded-md"
        :class="[
            isCurrentPlan ? 'bg-primary-200 border-primary-300' : 'bg-gray-100 border-gray-card',
            isClickable ? 'hover:bg-primary-200 hover:border-primary-300' : '',
            !isCurrentPlan && isClickable ? 'cursor-pointer group' : '',
        ]">
        <div class="absolute mr-2 mt-2 right-0">
            <svg v-if="isCurrentPlan" class="h-5 text-primary-500 w-5" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="check-circle" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"></path></svg>
        </div>
        <div class="border-b flex flex-col items-center pt-6"
            :class="[
                isCurrentPlan ? 'bg-primary-100 border-primary-300' : 'bg-white border-gray-200',
                isClickable ? 'group-hover:bg-primary-100 group-hover:border-primary-300' : '',
            ]">
            <h1 class="flex items-center leading-none mb-4 mt-0 text-2xl">
                <template v-if="isCurrentPlan">
                    <span class="text-gray-700">&euro;{{ application.pivot.price }}</span>
                    <span class="font-normal ml-1 text-2xs">/ {{ $t('organization_payments.month') }}</span>
                </template>
                <template v-else>
                    <span class="text-gray-700">&euro;{{ subscriptionPlan.price }}</span>
                    <span class="font-normal ml-1 text-2xs">/ {{ $t('organization_payments.month') }}</span>
                </template>
            </h1>
            <h2 class="font-medium mb-3 mt-0 text-gray-400 text-xs tracking-widest uppercase">
                {{ subscriptionPlan.name }}
            </h2>
        </div>
        <div class="px-4">
            <div class="flex flex-col font-medium items-center py-4 text-sm">
                <div class="my-px text-center">
                    {{ subscriptionPlan.user_limit ? subscriptionPlan.user_limit : $t('organization_payments.unlimited_male') }}
                    {{ subscriptionPlan.user_limit === 1 ? $t('organization_payments.user') : $t('organization_payments.users') }}
                </div>
                <div class="my-px text-center">
                    {{ subscriptionPlan.main_entity_limit ? subscriptionPlan.main_entity_limit : $t('organization_payments.unlimited_female') }}
                    <template v-if="application.slug === 'crm'">
                        {{ subscriptionPlan.main_entity_limit === 1 ? $t('organization_payments.account') : $t('organization_payments.accounts') }}
                    </template>
                    <template v-else-if="application.slug === 'tasks'">
                        {{ $t('organization_payments.projects') }}
                    </template>
                    <template v-else-if="application.slug === 'budgets'">
                        {{ $t('organization_payments.subdivisions') }}
                    </template>
                </div>
                <div v-if="application.slug === 'budgets'" class="my-px text-center">
                    {{ $t('organization_applications.unlimited_data_sources') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        application: {
            type: Object,
            required: true,
        },
        subscriptionPlan: {
            type: Object,
            required: true,
        },
        isClickable: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        isCurrentPlan() {
            return this.application.pivot.subscription_plan_id === this.subscriptionPlan.id;
        },
    },

    methods: {
        updateSubscriptionPlan() {
            if (!this.isClickable) {
                return false;
            }
            if (this.subscriptionPlan.id !== this.application.pivot.subscription_plan_id) {
                Bus.$emit('showUpdateSubscriptionPlanModal', { application: this.application, subscriptionPlan: this.subscriptionPlan });
            }
        },
    },
};
</script>
